import { Injectable } from '@angular/core';
import { StripeService } from 'ngx-stripe';
import { SubscriptionCheckoutService } from '../account/subscription-checkout.service';

@Injectable({
  providedIn: 'root'
})
export class StripeApiKeyInjector {
  constructor(private stripe: StripeService, private checkoutService: SubscriptionCheckoutService) {}

  public setStripePublishableApiKey(stripeApiKey: string) {
    this.stripe.changeKey(stripeApiKey);
    this.checkoutService.setApiKey(stripeApiKey);
  }
}
